import { render } from "./B2bTableSelectRows.vue?vue&type=template&id=4dcb503d&scoped=true&lang=pug"
import script from "./B2bTableSelectRows.vue?vue&type=script&lang=js"
export * from "./B2bTableSelectRows.vue?vue&type=script&lang=js"

import "./B2bTableSelectRows.vue?vue&type=style&index=0&id=4dcb503d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcb503d"]])

export default __exports__